import { useDispatch, useSelector } from 'react-redux';
import dynamicfunction from '../../utils/dynamicfunction';
import { getContentKeyAccToLang } from '../../utils/utils';
import { useNavigate } from 'react-router';
import { useEffect } from 'react';
import { getTicketingHistory } from '../../store/actions/settingAction';
import Text from '../../components/Text';
import { fontSizes } from '../../constants/constants';
import { domToReact } from 'html-react-parser';
import { getClientData } from '../../store/actions/investmentsAction';
import { setTicketingHistory } from '../../store/slices/settingSlice';

export default () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { TextWeight, isArabic, direction } = dynamicfunction();
  const { helpContent } = useSelector((state) => state.content);
  const { clientLoading } = useSelector((state) => state.investments);

  const { ticketing_history, ticketing_history_loading } = useSelector(
    (state) => state.setting
  );

  useEffect(() => {
    dispatch(setTicketingHistory([]))
    getdata();
  }, []);

  const getdata = async () => {
    await dispatch(
      getClientData((val) => {
        dispatch(getTicketingHistory(val?.clientInformation?.clientEmail));
      })
    );
  };

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      helpContent?.ticketing_history?.data?.attributes,
      key,
      isArabic
    );
  };

  const htmlParseOptions = {
    replace: (domNode) => {
      if (domNode?.name) {
        return (
          <Text
            text={domToReact(domNode?.children, htmlParseOptions)}
            isTruncate={false}
            color="text-primary"
            size={fontSizes.h14}
            weight={TextWeight.semiBold}
          />
        );
      }
    },
  };

  return {
    TextWeight,
    getContentKey,
    navigate,
    isArabic,
    direction,
    ticketing_history,
    ticketing_history_loading,
    htmlParseOptions,
    clientLoading,
  };
};
